<template>
  <div>
   <el-card>
        <el-alert
      title="企业朋友圈"
      type="warning"
      description="该数据每天9点左右会自动拉取前一天数据,同步数据最多只能获取最近1个月数据!
      个人类型无法查看详情,导出仅限于企业创建的朋友圈任务."
      show-icon>
  </el-alert>
   </el-card>
    <el-card :gutter="24">
      <el-row :gutter="24">
        <el-col :md="8" :lg="4">
            <el-select size="mini" v-model="params.corp_id" clearable placeholder="切换企业" @change="typesearch">
                <el-option v-for="item in corpList" :key="item.id" :label="item.title" size="mini" :value="item.id"> </el-option>
            </el-select>
        </el-col>
       <el-col :span="7"  >
        <div class="block">
            <el-date-picker
            size="mini"
              v-model="params.times"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right">
            </el-date-picker>
          </div>
      </el-col>
      <el-col :span="3">
        <el-select v-model="params.create_type" size="mini" placeholder="朋友圈创建来源">
        <el-option
          v-for="item in createArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          >
        </el-option>
      </el-select>
      </el-col>
        <el-col :span="3">
        <el-select v-model="params.visible_type" size="mini" placeholder="可见范围类型">
        <el-option
          v-for="item in visibleArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          >
        </el-option>
      </el-select>
      </el-col>
        <el-col :span="5" >
          <el-button type="primary"  @click="typesearch" size="mini">搜索</el-button>
          <el-button type="danger"  @click="getSync" size="mini">同步数据</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="每天9点会定时更新拉取更新数据!">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
   </el-card>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="content" label="内容" ></el-table-column>
      <el-table-column prop="name" label="创建人" ></el-table-column>
      <el-table-column prop="create_type" label="创建来源" >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.create_type == 0" >企业</el-tag>
            <el-tag type="info" v-else-if="scope.row.create_type == 1" >个人</el-tag>
            <el-tag type="info" v-else>所有</el-tag>
          </template>
      </el-table-column>
       <el-table-column prop="create_type" label="可见范围" >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.visible_type == 0" >部分可见</el-tag>
            <el-tag type="info" v-else-if="scope.row.visible_type == 1" >公开</el-tag>
            <el-tag type="info" v-else>所有</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" >
        <template slot-scope="scope">
          <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column  label="操作">
        <template slot-scope="scope" v-if="scope.row.create_type == 0">
          <el-button type="text" @click="getInfo(scope.row)">查看发送详情</el-button>
           <el-button type="text"  @click="getExport(scope.row)" size="mini">导出明细</el-button>
        </template>
      </el-table-column>
    </el-table>
     <div class="content-center content-top-padded">
          <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page_no"
                  :page-sizes="[10,20,50]"
                  :total="total_count"
                  :page-size="params.pageSize">
          </el-pagination>
      </div>
      <el-dialog title="朋友圈发表明细" :visible.sync="dialogTableVisible">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>已发表</span>
          <el-button style="float: right; padding: 3px 0" type="text">已发表数量:{{infoData.send_total}}</el-button>
        </div>
        <div>
          <el-tag  type="success" v-for="(item,index) in infoData.send" :key="index">
            {{item.name}}
          </el-tag>
        </div>
      </el-card>
         <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>待发表</span>
          <el-button style="float: right; padding: 3px 0" type="text">待发表数量:{{infoData.not_send_total}}</el-button>
        </div>
         <div>
          <el-tag  type="danger" v-for="(item,index) in infoData.not_send" :key="index">
            {{item.name}}
          </el-tag>
        </div>
      </el-card>
      </el-dialog>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getMomentList ,getCropList,getMomentTaskList,syncMoment,getMomentExport} from '../../api/workwx'
  export default {
    data () {
      return {  
         dialogTableVisible: false,
        total_count: 0,
        editVisible:false,
        submitLoading:false,
        editTitle: '',
        params: {
          page_no: 1,
          pageSize: 20,
          corp_id:'',
          create_type:0,
        },
        createArr:[
          {
            value:0,
            label:'企业',
            selected:true
          },
          {
            value:1,
            label:'个人',
            selected:false
          }
        ],
        visibleArr:[
          {
            value:0,
            label:'部分可见',
            selected:false
          },
          {
            value:1,
            label:'公开',
            selected:false
          }
        ],
        infoData:[],
        contactData:[],
        catesList:[],
        corpList:[],
        loading:false,
        memberTagDialog: false,
        newStatus:false,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page_no = page_num
        this.getDataList()
      },
      // 获取企业列表
      getCropList(){    
        getCropList(this.params).then(res => {
          this.corpList = res.data.data.list
          this.params.corp_id = this.corpList[0].id
           this.getDataList()
          })
      },
      typesearch () {
        this.params.page_no = 1
        this.getDataList()
      },
      handleSizeChange (pageSize) {
          this.params.page_no = 1
          this.params.pageSize = pageSize
          this.getDataList()
      },
      handleEdit(){
        this.editVisible = false
        this.editTitle = ""
      },
      getDataList () {
        this.loading = true
        getMomentList(this.params).then(response => {
          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.deplist = response.data.data.dep
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      getSync(){
          this.$confirm('此操作将进行数据同步变更, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             if(this.params.times == undefined || this.params.times==null){
              this.$notify({
                    title: '失败!',
                    message: '请选择时间!',
                    type: 'error'
                  });
                   return false;
            }
           if(this.params.corp_id==undefined || this.params.corp_id==null){
            this.$notify({
              title: '提示',
              message: '请选择企业!',
              type: 'error'
            });
            return false;
          }else{
             syncMoment(this.params).then(res=>{
              this.$notify({
              title: '成功',
              message: '已加入队列!',
              type: 'success'
            });
          })
          }
        }).catch((error) => {
          this.$message({
            type: 'info',
            message: '已取消同步数据!'
          });
        });
      },
      getInfo(row){
        this.dialogTableVisible=true
        getMomentTaskList({corp_id:row.corp_id,moment_id:row.moment_id}).then(res=>{
          this.infoData=res.data.data
        })
      },
      getExport(row){
        this.$notify({
            title: '成功',
            message: '正在导出,请稍后...',
            type: 'success'
          })
        getMomentExport({corp_id:row.corp_id,moment_id:row.moment_id}).then(res=>{
            if(res.data.data.status){
                this.$notify({
                  title: '成功',
                  message: '已加入队列!',
                  type: 'success'
                })
                 var url=res.data.data.url
                 window.open(url)
            }else{
              this.$notify({
                  title: '失败',
                  message: '出错了!',
                  type: 'error'
                })
            }
        })
      }
    },
    mounted () {
      this.getCropList();
 
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>


// WEBPACK FOOTER //
// moment.vue?ec05347a